export default "__VITE_ASSET__BOgQJZMs__"